import { createFileRoute } from '@tanstack/react-router';
import { ServicesPage } from '@/features/crm/pages/services-page';

const TABS = ['services', 'categories', 'packages', 'followups'] as const;

export const Route = createFileRoute('/_app/settings/services/')({
  validateSearch: (
    s: Record<string, unknown>,
  ): { tab?: (typeof TABS)[number]; q?: string; cat?: string } => ({
    tab: TABS.find((t) => t === s.tab),
    q: typeof s.q === 'string' && s.q ? s.q : undefined,
    cat: typeof s.cat === 'string' && s.cat ? s.cat : undefined,
  }),
  component: ServicesPage,
});
